import '../scss/forum-topic.scss';

import 'lazysizes';
import '../common';
import addToCart from '../components/cart.js';
import {createComment, readComments} from '../components/comment';
import saveRating from '../components/rating';
import {makeResponsive} from "../components/responsitive";


addToCart();
makeResponsive();
createComment();
readComments();
saveRating();